import { SearchResult } from '@rygen/rygen-ui/model';

import { Carrier } from './Carrier';

export class CarrierSearchResult extends SearchResult<Carrier> {
  constructor(opts?: Partial<CarrierSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new Carrier(val));
    }
  }
}
